import { SponsoredCardDto } from "./sponsored-card.dto";

export class SponsoredCardTranslationDto{
    constructor( 
        public id?:  number,
        public title?: string,
        public detail?: string,
        public distance?: string,
        public minPrice?: number,
        public maxPrice?: number,
        public currency?: string,
        public locale?: string,
        public sponsoredCard?: SponsoredCardDto
    ){}
}